import PropTypes from 'prop-types';

const InfoIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <g fill={fill} fillRule="evenodd">
        <path d="M21.227 34.36V23.372a2.774 2.774 0 0 1 5.546 0V34.36a2.774 2.774 0 0 1-5.546 0z" />
        <path
          d="M24 0c13.238 0 24 10.762 24 24S37.238 48 24 48 0 37.238 0 24 10.762 0 24 0zm0 4C12.971 4 4 12.971 4 24s8.971 20 20 20 20-8.971 20-20S35.029 4 24 4z"
          fillRule="nonzero"
        />
        <path d="M24 17.573a3.334 3.334 0 1 1 0-6.667 3.334 3.334 0 0 1 0 6.667z" />
      </g>
    </svg>
  </div>
);

InfoIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

InfoIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default InfoIcon;
